import baseCard from './base'
import hcsaCard from './hcsa'
import summaryCard from './summary'

export default {
  baseCard,
  hcsaCard,
  summaryCard
}



// WEBPACK FOOTER //
// ./src/styles/cards/index.js